import { hasValue } from 'utils/hasValue';

import { FundingSection } from '@pages/AccountTransactions/AccountDetails/FundingSection';
import { useGetCollectionFundingInstructions } from 'api';

import { useOrganisationId } from 'hooks/context';

import { BlindingDots } from '@atoms/BlindingDots/BlindingDots';
import { RollingLoader } from '@atoms/RollingLoader/RollingLoader';

export const AccountFundingInformation = ({
  virtualAccountNumber
}: {
  virtualAccountNumber: string;
}) => {
  const organisationId = useOrganisationId();
  const {
    data: { data: fundingInstructions } = {},
    isFetching,
    isSuccess,
    isError,
    refetch
  } = useGetCollectionFundingInstructions(Number(organisationId));

  const accountFundingInstructionsList =
    virtualAccountNumber && isSuccess && fundingInstructions
      ? fundingInstructions[virtualAccountNumber]
      : undefined;

  const currentAccountFunding = accountFundingInstructionsList?.find(
    (item) => item.virtual_account_number === virtualAccountNumber
  );

  const loadingText = 'Loading account funding information data';

  return (
    <div>
      {isFetching && (
        <div className="flex flex-col items-center gap-y-4 p-4">
          <RollingLoader ariaLabel={loadingText} />
          <div className="text-xs">
            <span className="invisible">...</span>
            <span>{loadingText}</span>
            <BlindingDots />
          </div>
        </div>
      )}

      {(isError || !hasValue(currentAccountFunding)) && (
        <div className="rounded-2xl bg-surface-neutral p-3 text-sm">
          Funding information not available for this account.
        </div>
      )}
      {!isFetching && !isError && currentAccountFunding && (
        <>
          <FundingSection
            fundingInstructions={accountFundingInstructionsList}
            refetch={refetch}
            accountNumber={virtualAccountNumber}
          />
        </>
      )}
    </div>
  );
};
